import { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200" role="banner">
      <div className="flex justify-between items-center h-16">
        <div className="flex items-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_import-duty-waiver/artifacts/fhafaydj_dd094932-baad-4705-8321-6271ac8eee4b.jpeg" 
            alt="TOR1 Services Logo" 
            className="h-8 w-auto cursor-pointer ml-3"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          />
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8 pr-6" aria-label="Main navigation">
          <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-blue-900 transition-colors">
            About
          </button>
          <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-900 transition-colors">
            Services
          </button>
          <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-blue-900 transition-colors">
            Pricing
          </button>
          <button onClick={() => scrollToSection('relocation-routes')} className="text-gray-700 hover:text-blue-900 transition-colors">
            Routes
          </button>
          <button onClick={() => scrollToSection('benefits')} className="text-gray-700 hover:text-blue-900 transition-colors">
            Benefits
          </button>
          <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-blue-900 transition-colors">
            Testimonials
          </button>
          <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-blue-900 transition-colors">
            FAQ
          </button>
          <Button onClick={() => scrollToSection('contact')} className="bg-blue-900 hover:bg-blue-800">
            Contact Us
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle mobile menu"
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <nav className="md:hidden py-4 px-3 border-t border-gray-200">
          <div className="flex flex-col space-y-4">
            <button onClick={() => scrollToSection('about')} className="text-left text-gray-700 hover:text-blue-900 transition-colors">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="text-left text-gray-700 hover:text-blue-900 transition-colors">
              Services
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-left text-gray-700 hover:text-blue-900 transition-colors">
              Pricing
            </button>
            <button onClick={() => scrollToSection('relocation-routes')} className="text-left text-gray-700 hover:text-blue-900 transition-colors">
              Routes
            </button>
            <button onClick={() => scrollToSection('benefits')} className="text-left text-gray-700 hover:text-blue-900 transition-colors">
              Benefits
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-left text-gray-700 hover:text-blue-900 transition-colors">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-left text-gray-700 hover:text-blue-900 transition-colors">
              FAQ
            </button>
            <Button onClick={() => scrollToSection('contact')} className="bg-blue-900 hover:bg-blue-800 w-full">
              Contact Us
            </Button>
          </div>
        </nav>
      )}
    </header>
  );
};
